import { useState } from "react";
import axios from "axios";
import { getHeaders } from "../utils/shared/headers";
import { EVENT_STATUS, CONTENT_TYPE } from "../constants/event";
import { fetchAndCacheState } from "../../Upshow";
import { BASE_URL } from "../constants/general";

function getToggleEndpoint (item, activeLiveContent) {
    if (item.contentType === CONTENT_TYPE.LIVE_CHANNEL) {
        const isPlayingThisChannel = activeLiveContent
            && activeLiveContent.contentType === CONTENT_TYPE.LIVE_CHANNEL
            && activeLiveContent.id === item.id;
        const action = isPlayingThisChannel ? 'unsubscribe_channel' : 'subscribe_channel';
        return `${BASE_URL}/v6/${action}/${item.id}`;
    }

    const isActive = [EVENT_STATUS.LIVE, EVENT_STATUS.COMING].includes(item.status);
    const shouldUnsubscribe = item.isDeviceSubscribed && !isActive;
    const action = shouldUnsubscribe ? 'unsubscribe' : 'subscribe';
    return `${BASE_URL}/v6/${action}/${item.id}`;
}

const useToggleSubscription = (fetchEvents, activeLiveContent) => {
    const [isSubscribeLoading, setIsSubscribeLoading] = useState(false);

    const handleToggleSubscription = async (item) => {
        setIsSubscribeLoading(true);
        try {
            const endpoint = getToggleEndpoint(item, activeLiveContent);
            await axios.post(endpoint, {}, { headers: getHeaders() });
            await fetchEvents(true);
            if (item.status === EVENT_STATUS.LIVE || item.contentType === CONTENT_TYPE.LIVE_CHANNEL) {
                await fetchAndCacheState();
            }
        } catch (err) {
            console.error("toggleSubscription error:", err);
        } finally {
            setIsSubscribeLoading(false);
        }
    };

    return { handleToggleSubscription, isSubscribeLoading };
};

export default useToggleSubscription;
